import { jsx } from 'react/jsx-runtime';
import 'react';

const Header = ({
  title
}) => {
  return /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center p-mili", children: /* @__PURE__ */ jsx("p", { className: "text-h5 font-bold text-primary-medium", children: title }) });
};

export { Header };
